exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".margin-bottom--1I-7y{margin-bottom:7px}.center--2cu_5{text-align:center;padding:14px}.max-width--3tu40{width:100%}.columnTile--2YlR7{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-line-pack:baseline;align-content:baseline}", "", {"version":3,"sources":["/workspace/src/widget/event_layouts/style.scss"],"names":[],"mappings":"AAAA,sBACE,iBAAkB,CACnB,AAED,eACE,kBAAkB,AAClB,YAAa,CACd,AAED,kBACE,UAAW,CACZ,AAED,mBACE,oBAAa,AAAb,oBAAa,AAAb,aAAa,AACb,4BAAuB,AAAvB,sBAAuB,CACxB","file":"style.scss","sourcesContent":[".margin-bottom {\n  margin-bottom: 7px;\n}\n\n.center {\n  text-align: center;\n  padding: 14px;\n}\n\n.max-width {\n  width: 100%;\n}\n\n.columnTile {\n  display: flex;\n  align-content: baseline;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"margin-bottom": "margin-bottom--1I-7y",
	"marginBottom": "margin-bottom--1I-7y",
	"center": "center--2cu_5",
	"max-width": "max-width--3tu40",
	"maxWidth": "max-width--3tu40",
	"columnTile": "columnTile--2YlR7"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--4-1!./node_modules/postcss-loader/lib??ref--4-2!./node_modules/sass-loader/lib/loader.js??ref--4-3!./src/widget/event_layouts/style.scss
// module id = 1380
// module chunks = 0